import type { ReactNode } from 'react';

/**
 * One pinned card on the House Guide overview (Wi-Fi, Check-out, House rules):
 * a small icon, a title, and whatever the card needs underneath. Kept local to
 * the guest screens rather than added to `packages/ui`, per FOUNDATION.md
 * Section 1 ("a new shared component is a request, not an edit") and Section 5
 * (`packages/ui/src/*` belongs to the foundation).
 */
export function GuideCard({
  icon,
  title,
  id,
  children,
}: {
  icon: ReactNode;
  title: string;
  id?: string;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      className="flex flex-col gap-3 rounded-2xl border border-line bg-surface p-4 scroll-mt-4"
    >
      <h2 className="flex items-center gap-2 font-display text-[1.15em] text-ink">
        <span className="text-accent" aria-hidden="true">
          {icon}
        </span>
        {title}
      </h2>
      {children}
    </section>
  );
}
